import { useRouteError } from 'react-router-dom'
import { AlertCircle } from 'lucide-react'

const ErrorBoundary = () => {
  const error = useRouteError() as Error

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full space-y-4 text-center">
        <div className="w-16 h-16 rounded-full bg-red-100 text-red-600 flex items-center justify-center mx-auto">
          <AlertCircle size={32} />
        </div>
        <h1 className="text-2xl font-bold">Bir Hata Oluştu</h1>
        <p className="text-muted-foreground">{error.message}</p>
        <button
          onClick={() => window.location.href = '/'}
          className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
        >
          Ana Sayfaya Dön
        </button>
      </div>
    </div>
  )
}

export default ErrorBoundary
